// Purchase options (radio cards or a dropdown): copy the chosen option's variant and selling plan
// into the form's hidden inputs, which are what the product form actually submits.
document.addEventListener('change', (event) => {
  const control = event.target;
  let source = null;
  if (control instanceof HTMLInputElement && control.type === 'radio' && control.dataset.variant) {
    source = control;
  } else if (control instanceof HTMLSelectElement && control.hasAttribute('data-buy-select')) {
    source = control.selectedOptions[0] || null;
  }
  if (!source || !source.dataset.variant) return;
  const form = control.closest('form');
  if (!form || !form.querySelector('[data-buy-variant]')) return;
  const variantInput = form.querySelector('[data-buy-variant]');
  const planInput = form.querySelector('[data-buy-plan]');
  if (variantInput) variantInput.value = source.dataset.variant;
  if (planInput) {
    planInput.value = source.dataset.plan || '';
    planInput.disabled = !source.dataset.plan;
  }
  // Show the headline price that matches the chosen pack size.
  const box = form.closest('[data-buy-box]');
  if (box) {
    const states = box.querySelectorAll('[data-buy-state]');
    const match = Array.from(states).some((state) => state.dataset.buyState === source.dataset.variant);
    if (match) {
      states.forEach((state) => {
        state.hidden = state.dataset.buyState !== source.dataset.variant;
      });
    }
  }
  // A subscription option shown before its plan exists is a preview only: pause the buy button.
  const submit = form.querySelector('button[type="submit"]');
  if (submit) {
    const isPreview = source.hasAttribute('data-preview');
    submit.disabled = isPreview;
    submit.classList.toggle('opacity-60', isPreview);
  }
});
